"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentOptionsResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
// There is an error exporting enums from common, remove this once we fix it
var DefaultOptionCategoriesIncidentEnum;
(function (DefaultOptionCategoriesIncidentEnum) {
    DefaultOptionCategoriesIncidentEnum["INCIDENT_TYPES"] = "incident_types";
    DefaultOptionCategoriesIncidentEnum["INCIDENT_PLACES"] = "incident_places";
    DefaultOptionCategoriesIncidentEnum["INCIDENT_ROLES_AND_REFERRALS"] = "incident_roles_and_referrals";
    DefaultOptionCategoriesIncidentEnum["STUDENT_WITH_SPECIAL_NEEDS"] = "student_with_special_needs";
    DefaultOptionCategoriesIncidentEnum["MOTIVATION"] = "motivation";
    DefaultOptionCategoriesIncidentEnum["OTHERS_INVOLVED"] = "others_involved";
    DefaultOptionCategoriesIncidentEnum["BULLYING"] = "bullying";
    DefaultOptionCategoriesIncidentEnum["BASIS_OF_BULLYING"] = "basis_of_bullying";
    DefaultOptionCategoriesIncidentEnum["PREVIOUS_ACTION_TAKEN"] = "previous_action_taken";
    DefaultOptionCategoriesIncidentEnum["HERO_DISPOSITION"] = "hero_disposition";
    DefaultOptionCategoriesIncidentEnum["LOCAL_DISPOSITION"] = "local_disposition";
    DefaultOptionCategoriesIncidentEnum["STATE_DISPOSITION"] = "state_disposition";
    DefaultOptionCategoriesIncidentEnum["INCIDENT_CONTEXT"] = "incident_context";
    DefaultOptionCategoriesIncidentEnum["SEVERITY_LEVEL"] = "severity_level";
    DefaultOptionCategoriesIncidentEnum["DUE_PROCESS"] = "due_process";
    DefaultOptionCategoriesIncidentEnum["DURATION"] = "duration";
})(DefaultOptionCategoriesIncidentEnum || (DefaultOptionCategoriesIncidentEnum = {}));
class IncidentOptionsResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (options)
            Object.assign(this, options);
    }
    getFields() {
        return Object.keys(DefaultOptionCategoriesIncidentEnum);
    }
    [DefaultOptionCategoriesIncidentEnum.BULLYING];
    [DefaultOptionCategoriesIncidentEnum.STATE_DISPOSITION];
    [DefaultOptionCategoriesIncidentEnum.INCIDENT_ROLES_AND_REFERRALS];
    [DefaultOptionCategoriesIncidentEnum.HERO_DISPOSITION];
    [DefaultOptionCategoriesIncidentEnum.INCIDENT_PLACES];
    [DefaultOptionCategoriesIncidentEnum.MOTIVATION];
    [DefaultOptionCategoriesIncidentEnum.OTHERS_INVOLVED];
    [DefaultOptionCategoriesIncidentEnum.PREVIOUS_ACTION_TAKEN];
    [DefaultOptionCategoriesIncidentEnum.STUDENT_WITH_SPECIAL_NEEDS];
    [DefaultOptionCategoriesIncidentEnum.BASIS_OF_BULLYING];
    [DefaultOptionCategoriesIncidentEnum.LOCAL_DISPOSITION];
    [DefaultOptionCategoriesIncidentEnum.INCIDENT_TYPES];
    [DefaultOptionCategoriesIncidentEnum.INCIDENT_CONTEXT];
    [DefaultOptionCategoriesIncidentEnum.SEVERITY_LEVEL];
    [DefaultOptionCategoriesIncidentEnum.DUE_PROCESS];
    [DefaultOptionCategoriesIncidentEnum.DURATION];
}
exports.IncidentOptionsResponseDto = IncidentOptionsResponseDto;
